define(["npm:moment@2.11.1/moment.js"], function(main) {
  return main;
});